import * as S from "./styles.ts";
import { useTypedSelector } from "@/redux/helpers/hooks.ts";
import CartDropdown from "./CartDropdown";
import ShoppingCart from "@template/icons/ShoppingCart.tsx";
import { Popup } from "@template/components";

interface ICartControlProps {
  altStyling?: boolean;
}

const CartControl = ({ altStyling }: ICartControlProps) => {
  const { cart } = useTypedSelector((state) => state.user);
  const active = cart.items.length > 0;

  return (
    <Popup
      popupContent={<CartDropdown />}
      offset={[0, 18]}
    >
      <S.CartControlContainer
        $altStyling={altStyling}
        $active={active}
      >
        <ShoppingCart
          height={22}
          width={22}
        />
        <S.Count>{cart.items.length > 100 ? "99+" : cart.items.length}</S.Count>
      </S.CartControlContainer>
    </Popup>
  );
};

export default CartControl;
